import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Subject } from "rxjs";

import { Field } from "@bpm/models";

const noop = () => {

};

export const CUSTOM_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CustomFieldComponent),
  multi: true
};

@Component({
    selector: "custom-field",
    templateUrl: "./custom-field.component.html",
    styleUrls: ["./custom-field.component.scss"],
    providers: [CUSTOM_CONTROL_VALUE_ACCESSOR],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CustomFieldComponent implements OnInit, OnDestroy, ControlValueAccessor {
  // Private
  private _unsubscribeAll: Subject<any>;
  private _value: any;

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  // Public
  public list: any[];

  @Input() field: Field;
  @Input() form: any;
  @Input() readOnlyStatus: boolean;
  @Input() lang?: string;

  @Output() changeValue: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Constructor
   * @param {HttpClient} _http
   */
  constructor() {
    this._unsubscribeAll = new Subject();
  }

  /**
   * Función que se ejecuta al iniciar este componente
   */
  ngOnInit(): void {
  }

  /**
   * Función que se ejecuta al finalizar de utilizar este componente
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  get value(): any {
    return this._value;
  }

  set value(obj: any) {
    if (obj !== this._value) {
      this._value = obj;
      this.onChangeCallback(obj);
    }
  }

  writeValue(obj: any): void {
    if (obj !== this._value) {
      this._value = obj;
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    throw new Error("Method not implemented.");
  }

  /**
   * Evento que se ejecuta al seleccionar un valor en el select
   * @param {any} obj Indica el objeto que cambio
   */
  onChange(obj: any){
    this.changeValue.emit(obj);
  }

}
